/**
 * Pin memory of the organizer side menu (mock `_kit/orgside.html`): `localStorage` `sf-osd` = "pin"
 * when the organizer pinned the panel open, absent = icon rail (the default). Storage is injectable
 * for tests; a throwing storage (private mode, blocked site data) reads as "rail".
 */
export const PIN_KEY = 'sf-osd'

const storageOf = (storage) => {
    if (storage !== undefined) return storage
    try {
        return globalThis.localStorage
    } catch {
        return null
    }
}

export const readPin = (storage) => {
    try {
        return storageOf(storage)?.getItem(PIN_KEY) === 'pin'
    } catch {
        return false
    }
}

export const writePin = (on, storage) => {
    try {
        const store = storageOf(storage)
        if (!store) return
        if (on) store.setItem(PIN_KEY, 'pin')
        else store.removeItem(PIN_KEY)
    } catch {
        /* private mode: the pin simply does not survive the reload */
    }
}
